import React from "react";
import { Translate } from "react-localize-redux";
import styled from "styled-components";

const SearchBoxWrapper = styled.div`
	padding: 0 20px 16px;

	@media (min-width: 1600px) {
		padding: 0 50px 20px;
	}
`;

const SearchInputWrapper = styled.button`
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	background: #1e2536;
	border: 1px solid #212734;
	border-radius: 10px;
	padding: 0 16px;
	height: 48px;
	cursor: pointer;
	transition:
		border-color 0.2s ease,
		background 0.2s ease;

	&:hover {
		border-color: rgba(255, 255, 255, 0.18);
		background: var(--color-azure-20, #232a3b);
	}

	@media (min-width: 768px) {
		height: 40px;
		border-radius: 14px;
	}
`;

const SearchIconSvg = () => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{ flexShrink: 0 }}>
		<circle
			cx="11"
			cy="11"
			r="7"
			stroke="#707290"
			strokeWidth="2"
		/>
		<path
			d="M16.5 16.5L21 21"
			stroke="#707290"
			strokeWidth="2"
			strokeLinecap="round"
		/>
	</svg>
);

const PlaceholderText = styled.span`
	color: #707290;
	font-size: 14px;
	font-weight: 500;
	user-select: none;
`;

const openSearch = () => {
	window.dispatchEvent(
		new CustomEvent("openCasinoSearchModal", {
			detail: { open: true },
		})
	);
};

const RollblockSearchBox = () => {
	return (
		<Translate>
			{({ translate }) => (
				<SearchBoxWrapper>
					<SearchInputWrapper
						type="button"
						onClick={openSearch}
						aria-label={translate("casino.gameSearch")}>
						<SearchIconSvg />
						<PlaceholderText>{translate("FIND_A_GAME")}</PlaceholderText>
					</SearchInputWrapper>
				</SearchBoxWrapper>
			)}
		</Translate>
	);
};

export default RollblockSearchBox;
